import { render } from "./Planner.vue?vue&type=template&id=4df8783e"
import script from "./Planner.vue?vue&type=script&lang=js"
export * from "./Planner.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__